// English product names inside the WMS (Fernando, 2026-10-26: "in the WMS we only use the EN version"). The server
// (backend/product_names.py) sends `product_name_en` beside every `product_name` it hands a screen, and `name_en`
// (with the size part) on order lines. `product_name` stays the customer's own words — the delivery note's — and is
// the hover text here, for whoever reads a customer's mail.
type Named = { product_name?: string | null; product_name_en?: string | null; name_en?: string | null;
               model_name?: string | null } | null | undefined;

/** The product's English name — the size part apart, as product_name is. */
export const titleEn = (p: Named): string => p?.product_name_en || p?.product_name || '';

/** The whole line in English, size part included. */
export const lineEn = (p: Named): string => p?.name_en || [titleEn(p), p?.model_name].filter(Boolean).join(' ');

/** Hover text: the customer's own words, when they differ from what the screen shows. */
export const customerWords = (p: Named): string | undefined => {
  const local = p?.product_name || '';
  return local && local !== titleEn(p) ? `Customer's language: ${[local, p?.model_name].filter(Boolean).join(' ')}` : undefined;
};
